<div class="button-container"
     [class.button-container-small]="buttonSize === 'SMALL'"
     [class.button-container-disabled]="disabled"
     [class.button-container-empty]="buttonType === 'EMPTY'"
     [class.button-container-full]="buttonType === 'FULL'"
     [class.button-container-block]="buttonType === 'BLOCK'"
     [class.button-container-light-background]="lightBackground"
     [class.button-container-outline]="buttonType === 'OUTLINE'">
  {{text}}
</div>
